module.exports = __webpack_public_path__ + "build/img/pho_s.647cc175.png";